import { incYenOf } from '../../../lib/pricing';
const commercialLaw = {
  'commercialLaw.page.backToTop': 'ページの先頭へ戻る',
  'commercialLaw.page.lastUpdated': '最終更新: 2026年6月13日',
  'commercialLaw.page.homeLink': 'ホーム',
  'commercialLaw.page.currentPage': '特定商取引法に基づく表記',

  'commercialLaw.hero.homeLink': 'ホーム',
  'commercialLaw.hero.currentPage': '特定商取引法に基づく表記',
  'commercialLaw.hero.title': '特定商取引法に基づく表記',
  'commercialLaw.hero.titleEn': 'COMMERCIAL TRANSACTIONS ACT',
  'commercialLaw.hero.lead': '一般社団法人全日本執事協会が運営する日本執事アカデミーの提供する教育サービスについて、特定商取引に関する法律第11条に基づき、以下の事項を表示いたします。',
  'commercialLaw.hero.imgAlt': '書類とペンを整然と配置した特定商取引法の表記ページ用の静物',

  'commercialLaw.jsonld.breadcrumb1': 'ホーム',
  'commercialLaw.jsonld.breadcrumb2': '特定商取引法に基づく表記',
  'commercialLaw.jsonld.orgName': '日本執事アカデミー',
  'commercialLaw.jsonld.parentOrg': '一般社団法人全日本執事協会',

  'commercialLaw.related.title': '関連ページ',
  'commercialLaw.related.0.title': 'プライバシーポリシー',
  'commercialLaw.related.0.desc': '個人情報の取扱い方針',
  'commercialLaw.related.1.title': '利用規約',
  'commercialLaw.related.1.desc': '本サイトの利用条件',
  'commercialLaw.related.2.title': 'お問い合わせ',
  'commercialLaw.related.2.desc': 'ご質問・ご相談はこちら',
  'commercialLaw.related.viewMore': '見る',

  // CommercialLawContent UI chrome
  'commercialLaw.toc.heading': '目次',
  'commercialLaw.content.preamble': '一般社団法人全日本執事協会が運営する日本執事アカデミーの提供する教育サービスについて、特定商取引に関する法律（特定商取引法）第11条に基づき、以下の事項を表示いたします。各項目の詳細については、それぞれ該当するページもあわせてご参照ください。',
  'commercialLaw.content.enactDate': '制定日',
  'commercialLaw.content.enactDateValue': '準備中',
  'commercialLaw.content.lastRevised': '最終改定日',
  'commercialLaw.content.lastRevisedValue': '2026年6月13日',
  'commercialLaw.content.amendNotice': '代表者名は確定次第、速やかに本ページを更新いたします。',
  'commercialLaw.content.noteTitle': '注記',
  'commercialLaw.content.noteText': '本表記は、特定商取引に関する法律第11条に基づき、役務（教育サービス）の提供に関する事項を表示したものです。価格その他の取引条件は予告なく変更する場合がございます。最新の情報は当サイトにてご確認ください。',

  // Item labels
  'commercialLaw.i.seller.label': '販売事業者',
  'commercialLaw.i.representative.label': '代表者',
  'commercialLaw.i.address.label': '所在地',
  'commercialLaw.i.phone.label': '電話番号',
  'commercialLaw.i.email.label': 'メールアドレス',
  'commercialLaw.i.price.label': '販売価格',
  'commercialLaw.i.extra-fees.label': '商品代金以外の必要料金',
  'commercialLaw.i.payment-method.label': '支払方法',
  'commercialLaw.i.payment-timing.label': '支払時期',
  'commercialLaw.i.service-timing.label': '役務の提供時期',
  'commercialLaw.i.cancellation.label': 'キャンセル・返金について',
  'commercialLaw.i.special-conditions.label': '特別の販売条件',

  'commercialLaw.i.seller.p.0': '一般社団法人 全日本執事協会',
  'commercialLaw.i.seller.p.1': '当協会は、日本執事アカデミーを運営し、執事教育サービスを提供する一般社団法人です。',

  'commercialLaw.i.representative.p.0': '準備中',
  'commercialLaw.i.representative.p.1': '代表者名は確定次第、速やかに本ページへ掲載いたします。現時点では「準備中」とさせていただきます。',

  'commercialLaw.i.address.p.0': '〒135-0064 東京都江東区青海2丁目7-4',
  'commercialLaw.i.address.p.1': '東京臨海新交通臨海線（ゆりかもめ）「東京国際クルーズターミナル駅」より徒歩約5分です。詳しいアクセス方法はアクセスページをご覧ください。',

  'commercialLaw.i.phone.p.0': '03-6824-4086',
  'commercialLaw.i.phone.p.1': '受付時間：平日 10:00〜17:00（土日祝日を除く）',
  'commercialLaw.i.phone.p.2': 'お電話でのお問い合わせは、上記の受付時間内にお願いいたします。時間外のお問い合わせは、お問い合わせフォームまたはメールにて承ります。',

  'commercialLaw.i.email.p.0': 'info@butler-academy.jp',
  'commercialLaw.i.email.p.1': 'お問い合わせはメールでも承っております。お気軽にご連絡ください。なお、お返事には2〜3営業日程度お時間をいただく場合がございます。',

  'commercialLaw.i.price.p.0': '各コースの受講料は以下のとおりです（いずれも消費税込みの総額表示）。',
  'commercialLaw.i.price.p.1': `・エッセンシャルコース：${incYenOf('ac-essential')}円（税込）`,
  'commercialLaw.i.price.p.2': `・アドバンスコース：${incYenOf('ac-advanced')}円（税込）`,
  'commercialLaw.i.price.p.3': `・マスターコース：${incYenOf('ac-master')}円（税込）`,
  'commercialLaw.i.price.p.4': `・体験講座：${incYenOf('ac-trial')}円（税込）`,
  'commercialLaw.i.price.p.5': '法人研修の価格は、各業種別プランページに記載しております。詳しくは料金概要ページおよび各コースページをご参照ください。',

  'commercialLaw.i.extra-fees.p.0': '銀行振込手数料は、受講生の皆様のご負担となります。',
  'commercialLaw.i.extra-fees.p.1': '出張を伴う実習または法人研修の実施にあたり、交通費および宿泊費が発生する場合は実費をご負担いただきます。',
  'commercialLaw.i.extra-fees.p.2': '教材費は受講料に含まれておりますので、別途ご負担いただく必要はございません。',

  'commercialLaw.i.payment-method.p.0': '銀行振込（一括払い）のみのお取扱いとなります。',
  'commercialLaw.i.payment-method.p.1': '分割払いおよびクレジットカードでのお支払いはご利用いただけません。あらかじめご了承ください。',
  'commercialLaw.i.payment-method.p.2': '法人研修の場合は、請求書払い（銀行振込）にて承ります。請求書は研修実施の約1ヶ月前にお送りいたします。',

  'commercialLaw.i.payment-timing.p.0': '受講料は、各コース開講日の14日前までにお振込みください。',
  'commercialLaw.i.payment-timing.p.1': '法人研修のお支払時期は、別途ご案内いたします。原則として、請求書到着後30日以内のお振込みをお願いしております。',

  'commercialLaw.i.service-timing.p.0': '各コースの開講日に役務の提供を開始いたします。開講日は年間スケジュールページにてご確認いただけます。',
  'commercialLaw.i.service-timing.p.1': '法人研修は、お客様と合意した実施日に研修を提供いたします。',
  'commercialLaw.i.service-timing.p.2': '体験講座は、各回の開催日が確定次第、当サイト上でご案内いたします。',

  'commercialLaw.i.cancellation.p.0': '本サービスは役務（教育サービス）の提供であるため、物品の返品には該当いたしません。',
  'commercialLaw.i.cancellation.p.1': 'キャンセルおよび返金の取扱いについては、募集要項に定めるキャンセル規定に従います。詳しくは応募資格・申込の流れのページをご確認ください。',
  'commercialLaw.i.cancellation.p.2': '開講日の14日前までにご連絡いただいた場合、所定の手数料を差し引いた金額をご返金いたします。開講日までの日数によりキャンセル料が異なりますので、募集要項を必ずご確認ください。',

  'commercialLaw.i.special-conditions.p.0': '各コースは定員6名、最少催行人数3名にて開校いたします。',
  'commercialLaw.i.special-conditions.p.1': '最少催行人数に満たない場合は、開校を見送らせていただく場合がございます。その際は、お振込みいただいた受講料を全額ご返金いたします。',
  'commercialLaw.i.special-conditions.p.2': '定員を超過した場合は先着順とし、次回以降の開講をご案内いたします。',
};

export default commercialLaw;
